import { DividerColor } from './Divider.types';

export const DIVIDER_COLOR: Record<DividerColor, string> = {
  primary: '--border-primary',
  secondary: '--border-secondary',
  tertiary: '--border-tertiary'
};
